import { Store } from 'pullstate'

const UIStore = new Store({
  isDarkMode: true,
  userProfile: null,
  selectedSite: null,
  qxrLicense: null
})

export default UIStore
